import ApplicationSerializer from './application';

/**
 * Attributes that `Api::V1::TasApplicationResource` (and its
 * DataStateCapable / ApiResource bases) mark read-only. The classic
 * JSONAPISerializer emits *every* attribute on `save()`, not just dirty ones,
 * so without this the API replies with a wall of "param not allowed" warnings
 * for each. Stripping them keeps the PATCH body to what the API will accept.
 */
const READ_ONLY_ATTRIBUTES = [
  'state',
  'paymentState',
  'coursesApproval',
  'evidenceApproval',
  'transitionLog',
  'approvedTotalLog',
  'paymentStateLog',
  'amounts',
  'history',
  'createdAt',
  'updatedAt',
  'dataState',
  'dataStateLog',
  'deletedAt',
];

/**
 * Owned / derived collections that must NOT be sent as relationship
 * replacements on a full `tas-application.save()`.
 *
 * `attachments` is polymorphic (`has_many as: :attachable`, `attachable_id`
 * NOT NULL) and `tasAssets` is `has_many :through`; the rest are read-only or
 * inverse-owned on the API. A full save serializes the model's *in-memory*
 * collection, which can be stale compared with the server. When jsonapi-resources
 * applies that as a to-many replace, ActiveRecord nulls the foreign key of any
 * member missing from the payload — e.g. `attachment.attachable_id` — raising
 * `PG::NotNullViolation` and a 500. Targeted add/remove still works because the
 * base serializer handles `createHasMany`/`destroyHasMany` adapterOptions
 * before this override runs.
 */
const RELATIONSHIPS_TO_OMIT = [
  'attachments',
  'tasAssets',
  'tasCourses',
  'tasAssistances',
  'tags',
  'pcsCards',
  'pcsCardEvents',
  'aiRecommendations',
  'comments',
  'messages',
  'employees',
];

export default class TasApplicationSerializer extends ApplicationSerializer {
  serializeAttribute(snapshot: unknown, json: unknown, key: string, attributes: unknown) {
    if (READ_ONLY_ATTRIBUTES.includes(key)) {
      return;
    }
    return super.serializeAttribute(snapshot, json, key, attributes);
  }

  serializeHasMany(snapshot: unknown, json: unknown, relationship: { key: string }) {
    if (RELATIONSHIPS_TO_OMIT.includes(relationship.key)) {
      return;
    }
    return super.serializeHasMany(snapshot, json, relationship);
  }
}
